export class BaseModelDTO {
    public code: string;
    public libelle: string;
}
